import {ApiClientService, EntityApiService} from '@dofleini/security';

import {authentication} from '@/settings';

class ActivityPlaceApiService extends EntityApiService {
  
  count = (params) => {
    return ApiClientService.post(this.getPath('/count'), params);
  }
  
  searchClean = (params, config) => {
    return ApiClientService.post(this.getPath('/searchClean', params), params, config);
  }
  
  exportExcel = async (params) => {
    return ApiClientService.post(this.getPath('/export?format=excel'), params);
  }
}

export default new ActivityPlaceApiService(`${authentication.path}/api/activityplaces`);
